/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 * News images button group component
 *
 * @author Alexander Golshtein
 * @author Evgeniy Naumov
 * @version 1.25.1
 * @since 1.25.0
 */

import { icons } from '@/main/assets';
import { ButtonGroupArrow, NewsImagesButtonGroupWrapper } from '@pages/PageNews/styled/NewsImagesStyled';

interface INewsImagesButtonGroupProps {
    next?: () => void;
    previous?: () => void;
}

const NewsImagesButtonGroup = ({ next, previous }: INewsImagesButtonGroupProps) => {
    return (
        <NewsImagesButtonGroupWrapper>
            <ButtonGroupArrow
                side="left"
                src={icons.arrowSliderLeft}
                onClick={() => {
                    if (previous) previous();
                }}
            />
            <ButtonGroupArrow
                side="right"
                src={icons.arrowSliderRight}
                onClick={() => {
                    if (next) next();
                }}
            />
        </NewsImagesButtonGroupWrapper>
    );
};

export default NewsImagesButtonGroup;
